module.exports = __webpack_public_path__ + "/login_ui/img/ca-71a0575ee5fd630d05181a7030a9d1c2.svg";